import React, { Component } from "react";
import Modal from 'react-bootstrap/Modal';
import classNames from 'classnames';
import { ErrorText } from '../../../components';

export default class DiscountModal extends Component {
    state = {
        discount: '',
        error: ''
    }

    componentDidUpdate(prevProps) {
        if (prevProps.data.discount !== this.props.data.discount) {
            this.setState({
                discount: this.props.data.discount,
            });
        }
    }


    onSave = () => {
        const { discount } = this.state;
        let error = '';
        if (discount === '') error = 'Required';
        else if (parseInt(discount) < 0 || parseInt(discount) > 100) error = 'Invalid percentage';

        if (error) {
            this.setState({ error });
        } else {
            this.props.handleApplyDiscount(discount);
        }
    }

    onInputChange = e => {
        this.setState({
            discount: e.target.value
        })
    }

    render() {
        const { discount, error } = this.state;
        const { show, onHide, data } = this.props;
  
        return (
            <Modal
                show={show}
                onHide={onHide}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Category Details
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row">
                        <div className="col-md-6 mb-2">
                            <div className="form-group">
                                <label>Name</label>
                                <p>{data.title}</p>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="form-group">
                                <label className={classNames({'text-danger': !!error})}>Discount</label>
                                <input
                                    type="number"
                                    value={discount}
                                    onChange={this.onInputChange}
                                    className={classNames('form-control', { 'is-invalid': !!error })}
                                />
                                <ErrorText error={error}/>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-danger" onClick={onHide}>Close</button>
                    <button className="btn btn-primary" onClick={this.onSave}>Save</button>
                </Modal.Footer>
            </Modal>
        )
    }
};